module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp1_5010.3d647434.png";